import type { ProviderId } from "@indeed/signals-schema/com/indeed/signals/schema/reactnative/ProviderId";

export const JSTReportLevel = {
  INFO: "info",
  WARN: "warn",
  ERROR: "error",
} as const;

export type JSTReportLevel = (typeof JSTReportLevel)[keyof typeof JSTReportLevel];

export interface JSTReportOptions {
  stack?: string | null;
  componentStack?: string | null;
  url?: string | null;
  statusCode?: number | null;
  errDomain?: string | null;
  errCode?: number | null;
  context?: Record<string, string | number> | null;
  containsPII?: boolean;
}

type ReportFields = Omit<JSTReportOptions, "containsPII"> & {
  providerId: ProviderId;
  message: string;
  containsPII: boolean;
};

/** Payload sent to the native reporter. */
export type JSTReport = ReportFields & { level: JSTReportLevel };
